<template>
  <div class="person">
    <Head></Head>

    <div class="banner">
      <div class="content">
        <img src="../assets/Person.jpg" alt="">
        <h4 class="css1a8429752e20234"><span>学术高地</span></h4>
        <p>湖南红杏林科技有限公司中医，薪火相传，强健中国人！</p>
        <p>在“一颗红心只为照亮杏林”的使命感召下，湖南红杏林科技有限公司汇聚了一批颇具行业影响力的专家团队。</p>
        <p>他们有人出身中医世家，家学渊源；有人专注临床三十余载，独成一脉；有人由病入道，学员遍及国内外……<br/>
        每一个人都有非常丰富的中医底蕴，医术精湛，享誉业界；每个人都有中医人的一腔热血，一直在为中医的传承与复兴振臂疾呼，积极奔走。</p>
        <p>如今，他们齐聚，誓要并肩扛起中医复兴的伟大旗帜，通过学术交流传医布道，<br/>真正让中医造福于百姓！</p>
      </div>
    </div>

    <h2 class="css1a8429752e20234"><span>名家荟萃</span></h2>

    <div class="list">
      <div class="item">
        <div class="master clearfix">
          <div class="img">
            <img src="../assets/famous_p6.jpg" alt="">
          </div>
          <div class="text">
            <div class="title css1a8429752e20234">
              <span>中</span><span>医</span><span>经</span><span>典</span><span>学</span><span>科</span><span>学</span><span>术</span><span>带</span><span>头</span><span>人</span>
            </div>
            <h4 class="css1a8429752e20234">学校校长——张炳填</h4>
            <p>湖南中医药大学教授、博士生导师 中共党员</p>
            <p>曾任湖南中医药大学基础医学院副院长、公共课部主任、教务处、研究生处处长、人文信息管理学院院长、湖南养天和中医馆有限公司总经理等职。</p>
            <p>现任湖南省中医执业医师实践技能考试首席考官、湖南省中医和中西医结合学会肝病专业委员会副主任委员、湖南省针灸学会中医在线教育工作委员会班主任委员、湖南省中医和中西医结合学会中医基础专业委员会常务理事、湖南省中医药国际合作专业委员会常务理事、湖南省中医和西医结合学会中医经典与临床专业委员会学术顾问、《湖南中医药大学学报》编委会特约专家、《中华现代中西医杂志》、《中医药学刊》特约编审专家等职。</p>
            <p>曾主要承担《金匮要略》、《伤寒杂病论选讲》、《中医内科学》、《中医防治学》等课程教学；承担省部级科研、教研课题16项，获省中医药管理局科技进步一等奖1项，省教育厅优秀教学成果二等奖1项，三等奖3项，校级奖多项。获省教育厅普通高等学校优秀教务处先进工作者1次、省教育厅自学考试先进工作者1次、本校先进工作者、优秀教师多次、2018年获养天和大药房股份有限公司卓越高层管理干部1次；在国家级、省级医学杂志发表学术论文60余篇，其中有8篇被评为优秀论文；公开出版著作、教材50余部，其中担任主编副主编24部。</p>
          </div>
        </div>
      </div>



      <div class="item">
      <div class="master clearfix">
        <div class="img">
          <img src="../assets/famous_p7.png" alt="">
        </div>
        <div class="text">
          <div class="title css1a8429752e20234">
            <span>脏</span><span>腑</span><span>点</span><span>穴</span><span>名</span><span>家</span>
          </div>
          <h4 class="css1a8429752e20234">补土派脏腑点穴法第六代传人——白书芳</h4>
          <p>传统医药非物质文化遗产传承人</p>
          <p>现年87岁，师从补土派脏腑点穴第五代传人赵茹川老师。传承古道的同时，将脏腑点穴与少林内劲一指禅、信息思维疗法等结合起来，总结发扬了一套系统完善、效果显著的点穴推拿疗法。</p>
          <p>50年临床经验，在北京、大连、北戴河、邯郸等多处均开设过脏腑点穴专家门诊。接诊患者数以万计，其中不乏各类脏腑慢性疾病及疑难杂症。先后发表论文十余篇，多家媒体专题报道。</p>
          <p>年近鲐背之年，依然坚守在临床一线。擅长调理各类脏腑疾病、慢性疾病，如：胆结石、心脑血管、胃肠疾病、糖尿病、五劳七伤等症，均有众多临床实例，口碑明证。</p>
          <p>为使补土派脏腑点穴疗法得到更广泛的传播与发展，打破古老单一传承办法，遵循理论与实践相结合的原则，进行多元带徒，并择优培养了一批补土派脏腑点穴疗法第七代传承人。</p>
        </div>
      </div>
    </div>


      <div class="item">
        <div class="master clearfix">
          <div class="img">
            <img src="../assets/famous_p8.png" alt="">
          </div>
          <div class="text">
            <div class="title css1a8429752e20234">
              <span>脏</span><span>腑</span><span>点</span><span>穴</span><span>名</span><span>家</span>
            </div>
            <h4 class="css1a8429752e20234">补土派脏腑点穴法第七代传人、掌门人——白丽娟</h4>
            <p>民间疗法研究专业委员会健康管理理事</p>
            <p>白书芳老师之女，自2009年起，跟随父亲白书芳深研补土派脏腑点穴技法，得其真传，开启临床实践达十余年，擅长调理妇科病、脾胃病、抑郁症、颈肩腰椎病、盆骨修复、疑难杂症等。</p>
            <p>先后受邀参加2018、2019健康服务高峰论坛及第二届中医药发展健康服务业暨慢病防治国际论坛会，不断将补土派脏腑点穴的成果推广到更广阔的舞台。</p>
          </div>
        </div>
      </div>


    </div>

    <div class="exchange">
      <div class="content">
        <h4 class="css1a8429752e20234"><span>学术交流</span></h4>
        <p>每一年，都会在线上线下举办各类中医学术交流活动。短短4年间，吸引了100多万中医从业者、爱好者参加，遍布全球数十个国家和地区，在业界颇具影响力。</p>


        <div class="preview">
          <div class="imgs">
            <img v-for="(item,index) in imgs" :class="{'active':active == index}" :src="item" :key="index">
          </div>
          <div class="left" @click="goLeft"><img src="../assets/left.png" alt=""></div>
          <div class="right" @click="goRight"><img src="../assets/right.png" alt=""></div>
        </div>
      </div>

      <div class="previewsBox">
        <ul class="previews" :style="{'margin-left':-250*(active>num?(active-num):0)+'px'}">
          <li class="img" :class="{'active':active === index}" v-for="(item,index) in imgs" @click="switchImg(index)" :key="index">
            <img :src="item">
          </li>
        </ul>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'
import seminar1 from '@/assets/seminar1.jpg'
import seminar2 from '@/assets/seminar2.jpg'
import seminar3 from '@/assets/seminar3.jpg'
import seminar4 from '@/assets/seminar4.jpg'
import seminar5 from '@/assets/seminar5.jpg'
import seminar6 from '@/assets/seminar6.jpg'
import seminar7 from '@/assets/seminar7.jpg'
import seminar8 from '@/assets/seminar8.jpg'
import seminar9 from '@/assets/seminar9.jpg'
import seminar10 from '@/assets/seminar10.jpg'
import g1 from '@/assets/g1.jpg'
import g2 from '@/assets/g2.jpg'
import g3 from '@/assets/g3.jpg'
import g4 from '@/assets/g4.jpg'
import g5 from '@/assets/g5.jpg'
import g6 from '@/assets/g6.jpg'
import g7 from '@/assets/g7.jpg'
import g8 from '@/assets/g8.jpg'
import g9 from '@/assets/g9.jpg'

export default {
  name: 'person',
  data(){
    return {
      imgs:[
        g1,g2,g3,g4,g5,g6,g7,g8,g9,
        seminar1,
        seminar2,
        seminar3,
        seminar4,
        seminar5,
        seminar6,
        seminar7,
        seminar8,
      ],
      active:0,
      timer:null,
      num:3
    }
  },
  components: {
    Head,
    Foot
  },
  mounted(){
    this.loop();
    this.num = parseInt(window.innerWidth / 250)-1;
  },
  methods:{
    switchImg(index){
      this.active = index;
      clearInterval(this.timer);
      this.loop();
    },
    loop(){
      this.timer = setInterval(()=>{
        if(this.active < this.imgs.length-1){
          this.active++;
        }else{
          this.active = 0;
        }
      },2000)
    },
    goLeft(){
      if(this.active == 0){
        this.active = this.imgs.length - 1;
      }
      this.active--;
      clearInterval(this.timer);
      this.loop();
    },
    goRight(){
      if(this.active == this.imgs.length - 1){
        this.active = 0;
      }
      this.active++;
      clearInterval(this.timer);
      this.loop();
    }
  }
}
</script>
<style scoped>
.banner{
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  background: #a43b45 url(../assets/famous_bg1.jpg) no-repeat center bottom;
  padding: 166px 0 90px;
  color: #fff;
}
.banner .content{
  max-width: 1165px;
  margin: 0 auto;
}
.banner .content p{
  max-width: 960px;
}
.banner h4{
  font-size: 34px;
  line-height: 49px;
  margin-top: 80px;
}
.banner span{
  display: inline-block;
  border-bottom: 2px solid #fff;
  padding-bottom: 5px;
}
.banner p{
  margin-top: 40px;
}
h2{
  font-size: 34px;
  color: #9D2933;
  max-width: 1165px;
  margin: 80px auto 0;
  line-height: 49px;
}
h2 span{
  display: inline-block;
  border-bottom: 2px solid #9D2933;
  padding-bottom: 5px;
}
.list{
  width: 100%;
  max-width: 1165px;
  margin: 0 auto;
  overflow: hidden;
}
.item{
  margin: 90px auto;
  border-bottom: 1px solid #D2D2D2;
  padding-bottom: 60px;
}
.item:last-child{
  border: none;
}
.master{
  display: flex;
  overflow: visible;
}
.master .img{
  width: 300px;
  height: 376px;
  margin-right: 80px;
  float: left;
}
.master .text{
  flex: 1;
  max-width: 765px;
  float: right;
}
.master .title span{
  display: inline-block;
  width: 46px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  background: #9D2933;
  color: #fff;
  font-size: 24px;
  margin-right: 5px;
}
.master h4{
  margin-top:70px ;
  font-size: 24px;
}
.master p{
  margin-top: 40px;
}
.followers{
  margin-top: 80px;
}
.followers h4{
  font-size: 24px;
}
.followers ul{
  margin-top: 35px;
  display: flex;
  margin-left: -17px;
  margin-right: -17px;
  flex-wrap: wrap;
}
.follower {
  width: 265px;
  margin: 0 12px;
  text-align: center;
  margin-bottom: 10px;
  float: left;
}
.follower .img{
  width: 100%;
  height: 168px;

}
.follower .name{
  line-height: 54px;
}
.exchange{
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 130px 0;
  background: #9D2933 url(../assets/famous_bg2.jpg) no-repeat center bottom;
  color: #fff;
}
.exchange .content{
  max-width: 1165px;
  margin: 0 auto;
}
.exchange h4{
  font-size: 34px;
}
.exchange h4 span{
  display: inline-block;
  padding-bottom: 10px;
  border-bottom: 1px solid #fff;
}
.exchange p{
  margin-top: 80px;
  max-width: 765px;
}
.previewsBox{
  width:100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow-x: hidden;
}
.preview{
  margin-top: 60px;
  position: relative;
  padding-bottom: 58%;
}
.preview .imgs{
  position: relative;
  height: 100%;
}
.preview .imgs img{
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: 1s;
}
.preview .left,.preview .right{
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  padding: 20px;
  top: 265px;
  cursor: pointer;
}
.preview .left{
  left: 20px;
}
.preview .right{
  right: 20px;
}
.preview .left img,.preview .right img{
  width: 36px;
}
.preview img.active{
  opacity: 1;
}
.previews{
  margin-top: 28px;
  margin-left: -10px;
  margin-right: -10px;
   white-space:nowrap;
   transition: 1s;
   text-align: center;
}
.previews .img{
  display: inline-block;
  width: 230px;
  height: 144px;
  margin: 0 10px;
  opacity: 0.6;
  cursor: pointer;
}
.previews .img img{
  width: 230px;
  height: 144px;
}
.previews .active{
  opacity: 1;
}
</style>

